// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
/* TODO: Remove, as it appears to be deprecated. */
import { Resources } from '@shared/localizations/Resources';
import { AlertSubImage, AlertType, AlertTypeMap, getAlertConditionKey } from '@shared/utils/Alert/AlertConstants';
import { QuickTableEditingInfo } from '../elements/QuickTable/QuickTableMisc';
import { BaseItem, ColumnData } from './BaseItem';
import { ColumnParams } from './ColumnParams';
import { ThemeManager } from '../misc/ThemeManager';
import { DynProperty } from '@shared/commons/DynProperty';
import { StringUtils } from '@shared/utils/StringUtils';
import { TableTotalsVisibility } from './TableTotalsVisibility';
import { QTAlignment } from '../elements/QuickTable/QuickTableColumn';
export class AlertItem extends BaseItem {
    constructor(alert) {
        super();
        this.QuickTableEditingInfoMap = {};
        this.alert = alert;
        super.ItemId = alert === null || alert === void 0 ? void 0 : alert.AlertId;
        this.QuickTableEditingInfoMap[AlertItem.ACCOUNT_COL_INDEX] = new QuickTableEditingInfo(DynProperty.TRUNCATE_TEXT_ADDING_ELLIPSIS);
        this.QuickTableEditingInfoMap[AlertItem.CONDITION_COL_INDEX] = new QuickTableEditingInfo(DynProperty.TRUNCATE_TEXT_ADDING_ELLIPSIS);
        this.QuickTableEditingInfoMap[AlertItem.EDIT_BUTTONS_COL_INDEX] = new QuickTableEditingInfo(DynProperty.ALERT_BUTTONS_GROUP);
    }
    getQuickTableCellForeground(column) {
        if (column === AlertItem.INSTRUMENT_COL_INDEX) {
            return ThemeManager.colors.tableSymbolForeground;
        }
        else {
            return super.getQuickTableCellForeground(column);
        }
    }
    getColumnData(column) {
        const value = this.getColumnValue(column);
        const formattedValue = value != null ? value.toString() : StringUtils.NOT_AVAILABLE;
        return new ColumnData(value, formattedValue);
    }
    getColumnValue(column) {
        const alert = this.alert;
        const instrument = alert.Instrument;
        const account = alert.Account;
        switch (column) {
            case AlertItem.INSTRUMENT_COL_INDEX:
                return instrument.DisplayName();
            case AlertItem.CONDITION_COL_INDEX:
                return `${Resources.getResource('panel.watchlist.' + AlertTypeMap[alert.AlertType])} ${Resources.getResource(getAlertConditionKey(alert.Condition))} ${this.formatConditionValue(alert)}`;
            case AlertItem.ACCOUNT_COL_INDEX:
                return account != null ? account.toString() : '';
            case AlertItem.EDIT_BUTTONS_COL_INDEX:
                return '';
            default:
                return null;
        }
    }
    formatConditionValue(alert) {
        if (alert.AlertType === AlertType.CHANGE) {
            return alert.Value.toFixed(2);
        }
        else if (alert.AlertType === AlertType.VOLUME) {
            return alert.Value.toString();
        }
        else {
            return alert.Instrument.formatPrice(alert.Value);
        }
    }
    static GetMenuIndex(headerKey) {
        const index = AlertItem.ListMenuIndex.indexOf(headerKey);
        return index !== -1 ? index : 1000;
    }
    ColumnCount() {
        return AlertItem.columnsParams.length;
    }
    GetColumnParams(column) {
        const params = AlertItem.columnsParams[column];
        params.Hidden = params.DefaultHidden;
        params.MenuIndex = AlertItem.GetMenuIndex(params.HeaderKey);
        return params;
    }
    GetImage(image, hover) {
        const images = ThemeManager.Images;
        switch (image) {
            case AlertSubImage.PLAY_STOP:
                return this.getImageByAlertStatus(images, hover);
            case AlertSubImage.UPDATE:
                return hover ? images.alert_update_hover : images.alert_update;
            case AlertSubImage.CLOSE:
                return hover ? images.alert_close_hover : images.alert_close;
            default:
                return null;
        }
    }
    getImageByAlertStatus(theme, hover) {
        const active = this.alert.Active;
        return active
            ? hover
                ? theme.alert_stop_hover
                : theme.alert_stop
            : hover
                ? theme.alert_play_hover
                : theme.alert_play;
    }
}
AlertItem.INSTRUMENT_COL_INDEX = 0;
AlertItem.CONDITION_COL_INDEX = 1;
AlertItem.ACCOUNT_COL_INDEX = 2;
AlertItem.EDIT_BUTTONS_COL_INDEX = 3;
AlertItem.columnsHeaderLocKey = {
    [AlertItem.INSTRUMENT_COL_INDEX]: 'general.Instrument',
    [AlertItem.CONDITION_COL_INDEX]: 'screen.Alerts.TableItem.Condition',
    [AlertItem.ACCOUNT_COL_INDEX]: 'AdditionalProperty.Account',
    [AlertItem.EDIT_BUTTONS_COL_INDEX]: ''
};
AlertItem.columnsParams = [
    new ColumnParams(AlertItem.columnsHeaderLocKey[AlertItem.INSTRUMENT_COL_INDEX], 75, QTAlignment.Left, TableTotalsVisibility.None, true, false),
    new ColumnParams(AlertItem.columnsHeaderLocKey[AlertItem.CONDITION_COL_INDEX], 100, QTAlignment.Left, TableTotalsVisibility.None, true, false),
    new ColumnParams(AlertItem.columnsHeaderLocKey[AlertItem.ACCOUNT_COL_INDEX], 50, QTAlignment.Left, TableTotalsVisibility.None, true, false),
    new ColumnParams(AlertItem.columnsHeaderLocKey[AlertItem.EDIT_BUTTONS_COL_INDEX], 50, QTAlignment.Center, TableTotalsVisibility.None, true, false)
];
AlertItem.ListMenuIndex = Object.values(AlertItem.columnsHeaderLocKey);
